import { Divider as MuiDivider, Typography } from '@material-ui/core';
import { Stack, useResponsiveValue } from '@superdispatch/ui';
import styled from 'styled-components';
import { QuickLoadAlertButton } from '../postings/QuickLoadAlertButton';

const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  width: 250px;
`;

const Divider = styled(MuiDivider)`
  flex: 1;
`;

export function CreateLoadAlertSection() {
  const isMobile = useResponsiveValue(true, true, false);
  return (
    <Stack space="small" align="center">
      <Wrapper>
        <Divider />
        <Typography color="textSecondary">or</Typography>
        <Divider />
      </Wrapper>

      <Typography align="center" color="textSecondary">
        Create a load alert and be notified when a load is posted in this area.
      </Typography>

      <QuickLoadAlertButton
        source="Similar Loads"
        title="Create Load Alert"
        variant="neutral"
        size="medium"
        fullWidth={isMobile}
      />
    </Stack>
  );
}
